import React, { ReactNode } from 'react';
import { Header } from '../../../blocks/Page/Header';
import styles from './StickyHeaderLayout.module.scss';

export default function StickyHeaderLayout( {
	children,
	isActiveMobileMenu,
	toggleMobileMenu,
}: {
	children: ReactNode;
	isActiveMobileMenu: boolean;
	toggleMobileMenu: ( active: boolean ) => void;
} ) {
	return (
		<div className={ styles.root }>
			<Header
				isActiveMobileMenu={ isActiveMobileMenu }
				toggleMobileMenu={ toggleMobileMenu }
			/>
			{ children }
		</div>
	);
}
